import { render } from "./PanelSkills.vue?vue&type=template&id=80f6868a"
import script from "./PanelSkills.vue?vue&type=script&lang=js"
export * from "./PanelSkills.vue?vue&type=script&lang=js"

import "./PanelSkills.vue?vue&type=style&index=0&id=80f6868a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__